import '../style/root.css'
import { AppLayout, HelpPanel, TopNavigation, TopNavigationProps } from '@cloudscape-design/components';
import { ReactNode, useCallback, useEffect, useState } from 'react';
import { Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { createPortal } from 'react-dom';

interface LayoutProps {
  children: React.ReactNode;
  breadcrumbs?: React.ReactNode;
}

interface DemoPortalHeaderProps {
  children: ReactNode;
}

const DemoPortalHeader = ({ children }: DemoPortalHeaderProps) => {
  const domNode = document.querySelector('#header')!;
  return createPortal(children, domNode);
};


export function Layout({ children, breadcrumbs }: LayoutProps) {
  const auth = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const handleSignOut = useCallback(async () => {
    console.log('Signing out');
    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID!;
    const logoutUri = process.env.REACT_APP_COGNITO_LOGOUT_URI!;
    const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN!
    auth.signoutSilent();
    window.location.href = `https://${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  }, [auth]);

  useEffect(() => {
    if (!auth.isAuthenticated) {
      auth.signinRedirect({
        url_state: encodeURIComponent(window.location.pathname)
      });
    }
    if (auth.user?.profile?.['custom:groups'] !== undefined && auth.user?.profile?.['custom:groups'] !== null) {
      const groups = JSON.parse(auth.user.profile['custom:groups'] as string);
      if (!groups.includes('admin')) {
        setIsAdmin(false);
      } else {
        setIsAdmin(true);
      }
    }
  }, [auth, setIsAdmin])

  const utilities: TopNavigationProps.Utility[] = [
    {
      type: 'button',
      text: 'SFDC Tagging Guide',
      href: '/sfdc-tagging',
    },
    {
      type: 'button',
      text: 'FAQs',
      href: '/faq',
    },
    isAdmin ?
      {
        type: 'menu-dropdown',
        text: `Hi, ${auth?.user?.profile.given_name ?? 'User'}`,
        items: [{
          id: 'admin-dashboard',
          itemType: 'action',
          text: 'Admin Dashboard',
          href: '/admin',
        }],
      } : {
        type: 'button',
        text: `Hi, ${auth?.user?.profile.given_name ?? 'User'}`,
      },
  ]
  utilities.push({
    type: 'button',
    text: 'Logout',
    onClick: handleSignOut,
    external: false,
  },)
  return (
    <>
      <DemoPortalHeader>
        <TopNavigation
          identity={{
            href: '/',
            title: 'EdTech Demo Portal',
          }}
          utilities={utilities}
        />
      </DemoPortalHeader>
      <AppLayout

        navigationHide={true}
        breadcrumbs={breadcrumbs}
        tools={<HelpPanel header={<h2>EdTech Demo Portal Help</h2>}>
          <p>Welcome to the EdTech Demo Portal. This portal is a collection of live demos that meet common EdTech related use cases.</p>
          <p>This portal is for Amazonian use only.</p>
          <Divider />
          <p>Have questions? Want to chat? Join the conversation in Slack in the <Link target='_blank' to="https://amazon.enterprise.slack.com/archives/C086CE9RYRW">#edtech-demo-portal</Link> channel</p>
        </HelpPanel>}
        content={children}
      />
    </>
  );
}
